import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PreviousRoute } from "@nx/mono-common";
import { signInPreviousRouteContext } from "../constants/sign-in.constants";
import { SignInService } from "../services/sign-in.service";

@Injectable({
  providedIn: 'root'
})

export class SignInRootGuard  {

  constructor(private signInService: SignInService, private router: Router) {}

  canActivate(): boolean {
    const previousRouteRouter = new PreviousRoute(this.router, signInPreviousRouteContext);
    previousRouteRouter.dispatchStoreUpdate(this.signInService.dispatchUpdateSignInStore.bind(this.signInService));
    return true;
  }

  canDeactivate(): boolean {
    this.signInService.dispatchResetSignInStore();
    return true;
  };
}